"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.request = exports.ResponseError = void 0;
require("whatwg-fetch");
class ResponseError extends Error {
    constructor(response) {
        super(response.statusText);
        this.response = response;
    }
}
exports.ResponseError = ResponseError;
function tryParse(text) {
    try {
        const json = JSON.parse(text);
        return json;
    }
    catch (error) {
        return null;
    }
}
function parseResponse(response) {
    const contentType = response.headers.get('content-type');
    return contentType && contentType.indexOf('json') >= 0
        ? response.clone().text().then(tryParse)
        : response.clone().text();
}
function checkStatus(response) {
    if (response.status >= 200 && response.status < 300)
        return response;
    const error = new ResponseError(response);
    error.response = response;
    throw error;
}
async function request(url, options = {}) {
    const headers = {
        accept: 'application/json, text/plain',
        'content-type': 'application/json;charset=utf-8',
    };
    const config = {
        ...options,
        headers: { ...headers, ...options === null || options === void 0 ? void 0 : options.headers },
    };
    const response = await fetch(url, config).then(checkStatus).then(parseResponse);
    return response;
}
exports.request = request;
//# sourceMappingURL=request.js.map